import { render, staticRenderFns } from "./ScrollMenu.vue?vue&type=template&id=bac43fc0"
import script from "./ScrollMenu.vue?vue&type=script&lang=js"
export * from "./ScrollMenu.vue?vue&type=script&lang=js"
import style0 from "./ScrollMenu.vue?vue&type=style&index=0&id=bac43fc0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports